import React from 'react';

import { Alert, Box, Paragraph } from '@zillow/constellation-10';

import BillingConstants from '../constants/BillingConstants';

export type BillingErrorProps = {
  errorMsg: string;
};

const BillingError = ({ errorMsg }: BillingErrorProps) => (
  <Box css={{ paddingBottom: 'sm' }}>
    <Alert tone="critical">
      <Paragraph>{errorMsg}</Paragraph>
      <Box css={{ marginTop: 'sm' }}>
        <Paragraph>Please contact Zillow Group Rentals.</Paragraph>
        <Paragraph>
          {`Tel: ${BillingConstants.ZRN_BILLING_PHONE}, Email ${BillingConstants.ZRN_BILLING_EMAIL}`}
        </Paragraph>
      </Box>
    </Alert>
  </Box>
);

export default BillingError;
